import { createActionGroup, props } from "@ngrx/store";
import { ContractType } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataContractTypesActions = createActionGroup({
    source: "Data / Contract Types",
    events: {
        "Load": props<{ companyId: string; languageCode: string }>(),
        "Load Success": props<{ contractTypes: ContractType[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
